// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"aadae0cb","453":"7e3a0e37","455":"190db99e","977":"469659da"}[chunkId] + ".chunk.js";
};